function createOverlay(image) {
  const existing = image.parentElement.querySelector('.image-magnify-full-size');
  if (existing) existing.remove();

  const w = image.offsetWidth;
  const h = image.offsetHeight;

  const cloned = image.cloneNode();
  cloned.removeAttribute('class');
  cloned.style.cssText = `display:block;width:${w}px;height:${h}px;object-fit:cover;transform:scale(2);transform-origin:50% 50%;pointer-events:none;`;

  const overlay = document.createElement('div');
  overlay.setAttribute('class', 'image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.cssText = `overflow:hidden;position:absolute;top:0;left:0;width:${w}px;height:${h}px;z-index:999;pointer-events:none;`;
  overlay.appendChild(cloned);

  image.style.visibility = 'hidden';
  image.after(overlay);
  return overlay;
}

function moveWithHover(overlay, image, event) {
  const cloned = overlay.querySelector('img');
  if (!cloned) return;
  const rect = image.parentElement.getBoundingClientRect();
  const x = ((event.clientX - rect.left) / rect.width) * 100;
  const y = ((event.clientY - rect.top) / rect.height) * 100;
  cloned.style.transformOrigin = `${x}% ${y}%`;
}

function magnify(image) {
  const overlay = createOverlay(image);
  const container = image.parentElement;

  function onMove(event) {
    moveWithHover(overlay, image, event);
  }

  function dismiss() {
    image.style.visibility = '';
    overlay.remove();
    container.removeEventListener('mousemove', onMove);
    container.removeEventListener('mouseleave', dismiss);
    container.removeEventListener('click', dismiss);
  }

  container.addEventListener('mousemove', onMove);
  container.addEventListener('mouseleave', dismiss);
  container.addEventListener('click', dismiss);

  return overlay;
}

function enableZoomOnHover() {
  if (window.innerWidth < 990) return;
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    image.onclick = (event) => {
      event.stopPropagation();
      const overlay = magnify(image);
      moveWithHover(overlay, image, event);
    };
  });
}

enableZoomOnHover();
